import React from 'react';
import { useLayout } from '../../context/LayoutContext'; 
import ChatList from './components/ChatList';
import ChatHeader from './components/ChatHeader';
import ChatMessages from './components/ChatMessages';
import MessageInput from './components/MessageInput';
import SearchBar from './components/SearchBar';
import '../../assets/scss/views/WsspConnection.scss';

function WsspConnection() {
  const { theme } = useLayout();

  return (
    <div className={`GM__${theme}-whatsapp-container`}>
      <div className={`GM__${theme}-whatsapp-sidebar`}>
        <SearchBar />
        <ChatList />
      </div>
      <div className={`GM__${theme}-whatsapp-main-content`}>
        <ChatHeader />
        <ChatMessages />
        <MessageInput />
      </div>
    </div>
  );
}

export default WsspConnection;